import React from 'react'

import { setIsMessageModalOpen, setMessageModalContent } from '../../store/ui/uiSlice'
import * as Styled from './styles'
import { useAppDispatch } from '../../hooks'

interface Props {
  context?: string
  hideOnDesktop?: boolean
  dangerouslySetInfo: string
}

const InfoButton: React.FC<Props> = ({ context = '', hideOnDesktop = false, dangerouslySetInfo }) => {
  const dispatch = useAppDispatch()

  return dangerouslySetInfo ? (
    <Styled.InfoButton
      context={context}
      hideOnDesktop={hideOnDesktop}
      onClick={(event) => {
        event.stopPropagation()
        dispatch(
          setMessageModalContent({
            dangerouslySetMessage: dangerouslySetInfo,
          })
        )
        dispatch(setIsMessageModalOpen(true))
      }}
    >
      <i className="fas fa-info" aria-hidden="true" />
    </Styled.InfoButton>
  ) : null
}

export default InfoButton
